import { render, staticRenderFns } from "./HistoryMsgList.vue?vue&type=template&id=502b4e26&"
import script from "./HistoryMsgList.vue?vue&type=script&lang=js&"
export * from "./HistoryMsgList.vue?vue&type=script&lang=js&"
import style0 from "./HistoryMsgList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports